import React from 'react';

import { useClearCalculationForm } from 'app/shared/hooks/useClearCalculationForm';
import { ClearFormBox } from 'app/components/ClearFormBox';

export default function ShortPathSectionMessage() {
  const { clearForm } = useClearCalculationForm();

  return <ClearFormBox clearFunction={clearForm} />;
}
